module.exports = __webpack_public_path__ + "static/waterproof-mattress-protector-design-process-ae0a732beae2bd5a39c880e547226fb5.mp4";